import axios from "axios";
import { errorService } from "../Error/ErrorService";
import { URL_MIDIS, URLAPI } from "../../Setting";
import { Metier } from "../../Models/Abonnement/AbonnementModels";

export function MetierService(){
    return{
        async getMetierFromUrlForPack(url:string, token:string):Promise<Metier>{
            try {
                const response = await axios.get(`${URL_MIDIS+url}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                let metier:Metier = {
                    id:data[0]['id'],
                    nom:data[0]['nom'],
                }
                return metier;
            } catch (error) {
                errorService().handleError('Erreur lors du getPacksForAdmin', error)
                return {id:0,nom:''};
            }
        },

        async getMetiersForPacksAdmin(token:string):Promise<Metier[]>{
            try {
                const response = await axios.get(`${URLAPI+'metiers'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                let metiers:Metier[]=[];
                for(const element of data){
                    metiers.push({
                        '@id':element['@id'],
                        id:element['id'],
                        nom:element['nom'],
                    });
                }
                return metiers;
            } catch (error) {
                console.log('erreur : ', error)
                return [];
            }
        }
    }
}